/**
 * Componente costos para paso de corriente.
 * @module passCurrentCostController
 * @return {Object} ctrl
 */
function passCurrentCostController() {
var vm = this;
	/* Define variables */


	/* Define funciones */
	vm.CostCaptureC = CostCaptureC;
	vm.CostCaptureNC = CostCaptureNC;

	/* Implementacion */
	/** @static
	 * @function
	 * @name CostCaptureC
	 * @description Contruye objeto de costos capturado Carretero
	 * @param      {String}  service - id de asistencia
	 * @param      {String}  beginningtrip - costo por inicio de viaje
	 * @param      {String}  kilometerstraveledCost - costos por kilometros recorridos
	 * @param      {String}  kilometerstraveled - kilometros recorridos
	 * @param      {String}  tollbooths - costo por cabijas de peaje
	 * @param      {String}  waittime - costo por tiempo de espera
	 * @param      {String}  country - pais por proveedor
	 * @return 	{void}
	 */
	function CostCaptureC(service, beginningtrip, kilometerstraveledCost, kilometerstraveled, tollbooths, waittime, country) {

        var res;

        if (country === 'CO') {

            res = {
                service: service,
                beginning_trip: beginningtrip,
                kilometers_traveled: kilometerstraveled,
                kilometers_traveledCost: kilometerstraveledCost
            };
        } else {

            res = {
                service: service,
                beginning_trip: beginningtrip,
                kilometers_traveled: kilometerstraveled,
                kilometers_traveledCost: kilometerstraveledCost,
                toll_booths: tollbooths,
                wait_time: waittime
            };

        }


        vm.getTimecos({
            service: res
        });
    }
	/** @static
	 * @function
	 * @name CostCaptureC
	 * @description Contruye objeto de costos capturado No Carretero
	 * @param      {String}  service -  id de asistencia
	 * @param      {String}  currentflow - costo por paso de corriente
	 * @param      {String}  waittime - costo por tiempo de espera
	 * @param      {String}  country - pais por proveedor
	 * @return 	{void}
	 */
	function CostCaptureNC(service, currentflow, waittime, country) {

        var res;

        if (country === 'CO') {
            res = {
                service: service,
                current_flow: currentflow
            };
        } else {
            res = {
                service: service,
                current_flow: currentflow,
                wait_time: waittime
            };
        }

        vm.getTimecos({
            service: res
        });
    }
}

angular
.module('app')
.component('passCurrentCost', {
	templateUrl: 'app/components/wrapperCost/passCurrentCost/passCurrentCost.html',
	controller: passCurrentCostController,
	controllerAs : 'ctrl',
	bindings : {
		data : '<',
		valCosts : '<',
		getTimecos : '&',
		service : '<',
		monitor : '<',
		status : '='
	}
});
